import React, { useEffect, useState, useRef } from 'react';
import { Typography, Paper } from '@material-ui/core';
import { connect } from "react-redux";
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import { DialogTitle, DialogContent, DialogActions } from '../../components/Dialog/Dialog';
import { TextField } from '@material-ui/core';
import { useForm, Controller } from 'react-hook-form';
import InputAdornment from '@material-ui/core/InputAdornment';
import { addNewParty, getPartyList, emptyPartyList,tripExpenseTypes,addTripExpenseTypes } from "../../../store/actions/tripActionCreator";
import {editVendor } from "../../../store/actions/vehicleActionCreator";
import { sendError, sendSucces } from "../../../utils/utils";
import * as logger from "../../../logger";
import { trackDwebEvent } from '../../analytics';


const styles = makeStyles(theme => ({
  formRoot: {
    '& .MuiFormControl-root': {
      width: '100%',
      margin: '16px 0px'
    }
  },
  error: {
    color: 'red',
    marginBottom: 8
  }
}))
const initialValues = {
  id: null,
  name: '',
  mobile: ''
}
const AddExpenseType = (props) => {
  const { children, user, defaultId, defaultName, defaultNumber,dispatchAddTripExpenseType,dispatchGetTripExpenseTypes, classes, open, onClose, onSave, ...other } = props;

  const [dialogopen, setDialogOpen] = React.useState(open);
  const inlineStyles = styles();
  const { register, handleSubmit, control, errors } = useForm({
    mode: 'onChange',
    reValidateMode: 'onChange',
    defaultValues: {
      name: defaultName ? defaultName : '',
      mobile: defaultNumber ? defaultNumber : '',
    },
  });

  const handleExpenseTypeSave = (e) => {
  }
  const handleClose = (status) => {
    onClose(false);
  };

  const onSubmit = data => {

    if (defaultId) {
      var vendorData = {
        name: data && data.name ? data.name : '',
      }
    }
    else {
      dispatchAddTripExpenseType(
        {
          name: data && data.name ? data.name : '',
        },
        (addResponse) => {
          if (addResponse && addResponse.status && addResponse.status.code && addResponse.status.code == 200) {
            //dispatchEmptyPartyList();
            dispatchGetTripExpenseTypes(() => {
              setTimeout(() => {
                handleClose();
                sendSucces("Expense Type Created Successfuly!")
                onSave(true, {
                  display:data && data.name ? data.name : '',
                  value:data.name
                });
              }, 300)
            },
              () => {

              })
          }
        },
        () => {
        }
      );
    }
  };
  return (
    <div>
      <Dialog fullWidth={true}
        maxWidth='xs'
        onClose={handleClose} disableEscapeKeyDown={true} disableBackdropClick={true} aria-labelledby="add-party-dialog-title" open={dialogopen}>
        <DialogTitle id="add-party-dialog-title" onClose={handleClose}>
          {!defaultId &&
            <span>Add Expense Type</span>
          }
          {defaultId &&
            <span>Edit Expense Type</span>
          }
        </DialogTitle>
        <DialogContent dividers>
          <form className={inlineStyles.formRoot} onSubmit={handleExpenseTypeSave} noValidate id="hook-form" onSubmit={handleSubmit(onSubmit)}>
            <TextField variant="outlined" size='small'
              required={true} name="name"
              label="Expense Name"
              placeholder="Enter a Expense Name"
              inputRef={register({
                required: 'You must provide a Name',
                minLength: {
                  value: 3,
                  message: 'Expense Name must be greater than 3 characters',
                },
                validate: {
                  spaceOnly: v => v.trim().length != 0,
                }
              })}
              error={!!errors.name}
              fullWidth
              autoFocus
            />
            {errors?.name?.type === "spaceOnly" ? (
                            <span className={inlineStyles.error}>Alphabetical characters only</span>
                            ):errors && errors.name && (
              <span className={inlineStyles.error}>{errors.name.message}</span>
            )}
          </form>
        </DialogContent>
        <DialogActions>
          <Button variant="contained" className='modal-close-cta' onClick={handleClose} >
            Close
          </Button>
          <Button type="submit" form="hook-form" variant="contained" className='modal-save-cta' onClick={handleExpenseTypeSave} >
            Save changes
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}
const mapStateToProps = (state) => (state);
const mapDispatchToProps = (dispatch) => ({
  dispatchGetTripExpenseTypes: (onSuccess,onFailure) =>dispatch(tripExpenseTypes(onSuccess, onFailure)),
  dispatchAddTripExpenseType: (data,onSuccess,onFailure) =>dispatch(addTripExpenseTypes(data,onSuccess, onFailure)),
});
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(AddExpenseType);